import { useState, useMemo } from 'react'
import { useInfiniteQuery } from 'react-query'

export function useInfinitePagination(requestName, api, options = {}) {
  const [lastPage, setLastPage] = useState(1)

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
    refetch,
    error
  } = useInfiniteQuery(requestName, api, {
    getNextPageParam: (lastFetchedPage) => {
      const lastPg = lastFetchedPage.data.pagination?.page || 1
      return lastPg < lastPage ? lastPg + 1 : null
    },
    select: (axiosData) => {
      const pages = axiosData.pages.flatMap(({ data: res }) => ({
        data: res?.data ?? []
      }))

      const pageParams = axiosData.pages.flatMap(
        ({ data: res }) => res?.pagination
      )

      return { pages, pageParams }
    },
    cacheTime: 0,
    ...options
  })

  const { isLastPage, rows } = useMemo(() => {
    const { pages, pageParams } = data ?? {}

    const fetchedPages = pages?.length
    const lastPg = Math.ceil(pageParams?.[0].total / pageParams?.[0].perPage)
    if (lastPage !== lastPg) {
      setLastPage(lastPg)
    }
    const allRows = pages?.flatMap((res) => res?.data ?? [])

    return {
      isLastPage: fetchedPages === lastPg,
      rows: allRows
    }
  }, [data, lastPage])

  return {
    originalData: data,
    data: rows,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
    refetch,
    error,
    isLastPage
  }
}
